import { ISearchPage, IPage,ICmSearchPageFields } from "../../../types/FmsTypes";
import { httpRequest } from "../../../utils/HttpRequest";


//详情
export interface ISCMPromptDetail {
    id: string, 
    branch?: string,
    systemName?: string,
    moduleName?: string,
    errorCode?: string,
    promptInformation?: string,
    pcode?: string
    [key:string]:any
}

//错误日志 实体
export interface ISCMBeDetails {
    id: string,                // "911332111d8134f89b45490410550079",
    code: string,                // null,
    orderNum: string,                // 0,
    deleteFlag: string,                // 0,
    createTime: string,                //,
    updateTime: string,                //,
    createUser: string,                // "默认用户",
    updateUser: string,                // null,
    promptCode: string,                // "ETY-M-gSUn-00000019",
    bentityCode: string,                // "实体编码-",
    bentityName: string,                // "实体名称-"
}

//新增
export interface ISCMPromptInsert {
    branch?: string,
    systemName?: string,
    moduleName?: string,
    errorCode?: string,
    promptInformation?: string,
    pcode?: string
}

//编辑
export interface ISCMPromptUpdate extends ISCMPromptInsert {
    id: string,
}

//搜索条件
export interface ISCMPromptSearchFields {
    enable?: string,      // "分支",
    stuats?: string,      // "状态",
    orgCode?: string,      // "机构编码",
    name?: string,      // "错误日志名称",
    sourceApp?: string,      // "mdm",
    [key:string]:any
}

export interface ISCMPromptSearch
    extends ISCMPromptSearchFields, ICmSearchPageFields {
}

//表单字段
export interface ISCMPromptFormFields {
    branch: string,
    code?: string,
    name: string,
    orgCode: string,
    orgName: string,
    contact: string,
    phone: string,
    address: string,
    status: boolean,
    categoryCode: string,
    categoryName: string,
    details: string[],
    note?: string,
    [key:string]:any
}

class PromptService {
    async page(searchVo: any) {
        const apiUrl = "/prompt/message/findPage";
        return await httpRequest.post<IPage<ISCMPromptDetail>>(apiUrl, searchVo);
    }
    async insert(insertVo: ISCMPromptInsert) {
        const apiUrl = "/prompt/message/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: ISCMPromptUpdate) {
        const apiUrl = "/prompt/message/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }

}

export const promptService = new PromptService();
